



























































import { Vue, Component } from 'vue-property-decorator';
import MainButton from '@/shared/buttons/main-button.component.vue';
import Pagination from '@/domain/pagination.entity';
import FilterProductTemplate from '@/domain/product-template/service/filter-product-template.entity';

@Component({
  components: {
    MainButton,
  },
})

export default class ProductTemplateFilter extends Vue {
  ref: any = this.$refs;

  filter = FilterProductTemplate.of({});

  pagination: Pagination = new Pagination({
    page: 0,
    itemsPerPage: 100,
    defaultSort: 'name|asc',
  })

  clear() {
    this.ref.form.reset();
    this.filter = new FilterProductTemplate({});
  }

  send() {
    this.$emit('filter', this.filter);
  }
}
